import { getBlockSize } from "@sperrdatei/dto/utils";

import type { ValidationResult } from "./validation-result";

export const validateComment = (
  value: string,
  number: string,
): ValidationResult => {
  if (value.length > 1024) {
    return {
      isValid: false,
      errorMessage: "Die maximale Länge beträgt 1024 Zeichen.",
    };
  }

  if (getBlockSize(number) >= 100 && value.length < 3) {
    return {
      isValid: false,
      errorMessage:
        "Für Rufnummernblöcke ab einer Größe von 100 Nummern ist eine Bemerkung vorgeschrieben.",
    };
  }

  return { isValid: true };
};
